
const Footer = ({show, hide}) => {
    const date = new Date()
    const style = {
        textAlign:'center',
        fontSize:'1.35rem'
    }
    return (
        <p style={style} className={`${show && 'footer__show'} ${ hide && 'footer__hide'}`}>
           الحقوق محفوظة لعائلة سعيد بن غنيم &copy; {date.getFullYear()}  -  تم تطوير هذا الموقع بواسطة عبدالرحمن مفلح المرواني
        </p>
    )
}

export default Footer
